import { BookOpenText, FolderDown, Link2, PlayCircle, type LucideIcon } from 'lucide-react'
import type { MaterialKind } from './types'

export const KIND_META: Record<MaterialKind, { label: string; icon: LucideIcon }> = {
  lesson: { label: 'Lesson', icon: BookOpenText },
  resource: { label: 'Resource', icon: FolderDown },
  link: { label: 'Link', icon: Link2 },
  video: { label: 'Video', icon: PlayCircle },
}
